.tr {
    &[data-odd='true'] {
        background-color: alpha(
            var(--mantine-color-ldGray-1),
            light-dark(0.3, 0.5)
        );
    }

    &:hover {
        background-color: alpha(
            var(--mantine-color-ldGray-1),
            light-dark(0.7, 0.7)
        ) !important;
    }

    &:hover td {
        filter: saturate(1) brightness(0.9);
    }
}
